import React from 'react';
import { DEBT_ANALYSIS } from 'types/morph.pagePosition.constants';
import SectionContainer from 'components/Containers/SectionContainer';
import { DebtAnalysisLink } from './DebtAnalysisLink/DebtAnalysisLink';
import { Row } from 'components/Containers/Row/Row';

const DebtAnalysis = props => {
  return (
    <>
      {props.seenPixel}
      <SectionContainer>
        <Row>
          <DebtAnalysisLink
            creditInfo={props.creditInfo}
            debtAnalysisState={props.whatsChangedMetadata}
            onLinkClickCallback={props.onLinkClickCallback}
            link={DEBT_ANALYSIS}
            module={DEBT_ANALYSIS}
            {...props}
          />
        </Row>
      </SectionContainer>
    </>
  );
};

DebtAnalysis.defaultProps = {
  titleText: 'Debt Analysis',
  icons: {
    debtTrend: null,
    monthlyPaymentTrend: null,
    rightPointingArrow: 'right_pointing_arrow_icon',
    dtiTrend: null,
  },
  debtToIncomeRatioTitleText: 'Debt To Income Ratio',
  debtTitleText: 'Total Debt',
  monthlyPaymentTitleText: 'Monthly Payments',
};

export default DebtAnalysis;
